export default "__VITE_ASSET__D56rNgE___"